// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"898ced86","3":"e59ad649","35":"c0e3e2a3","195":"90433544","224":"80fba6e4","299":"bb24f3bc","462":"61cf4eaa","465":"04f5f2c7","490":"256d2095","494":"da188513","512":"40f1eadc","531":"87ae1f3a","612":"7ebca151","761":"e6a279c3","875":"54fba884","898":"bc58c52a"}[chunkId] + ".chunk.js";
};